import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { generalConsultReducer } from './general.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('general', {
      consult: generalConsultReducer,
    }),
  ],
})
export class GeneralStoreModule {}
